export function initialize(model,uxview,sellerId) {
	$(window).on('popstate', function (e) {
		console.log(location.search)
		onPopStateChange(uxview, location.search,sellerId);
	});
	filterEventBinding(uxview, sellerId)
	viewUpdateEventBinding(model,uxview, sellerId)
}
export function changeKeywords(scope, uxview, queryStr, pageType, sellerId, onPop){
	return contentChangeDeferred(scope, uxview, queryStr, pageType, sellerId, onPop)
}

export function setSelectedCategoryToMiddleScroll(targetDOMElement, containerDOMElement, etcDOMElement) {
	if (targetDOMElement == null || containerDOMElement == null) return;
	var minusWidth = etcDOMElement == null ? 0 : etcDOMElement.offsetWidth;
	var targetOffset = getOffsetMiddle(targetDOMElement);
	var containerWidth = containerDOMElement.offsetWidth - minusWidth;
	var targetWidth = targetDOMElement.scrollWidth;
	var scrollLeftValue = targetOffset - (containerWidth / 2);
	$(containerDOMElement).scrollLeft(scrollLeftValue);
}

export function getOffsetMiddle(el, hasSpace) {
	var middle = el.offsetWidth / 2;
	if (el.offsetParent) {
		do { middle += el.offsetLeft; }
		while (el = el.offsetParent);
		return [middle];
	}
}

function getPageType() {
	var body = $('body');
	if (body.hasClass("page__corner--lp") || body.hasClass("page__minishop--lp")) return "LP";
	else if (body.hasClass("page__corner--srp") || body.hasClass("page__minishop--srp")) return "SRP";
	else { return "UNKNOWN" };
}
function getSellerId(){

	if(EBAY.EX_SHOP.sellerId != null && EBAY.EX_SHOP.sellerId != undefined) return EBAY.EX_SHOP.sellerId;
	else return"";
}

function bindCategoryNavigationFloating(uxview) {
	if (uxview !== "undefined" && uxview !== null) {
		$('.box__sub-list-wrap').each(function(){
			uxview.uio.oCategoryNavigation.initFloatingNav(this, 1, 41);
		});
	}
}

function viewUpdateEventBinding(model,uxview, sellerId) {
	bindCategoryNavigationFloating(uxview);
	$('body').on('click', '.update-page', (function (e) {

		e.preventDefault();
		var body = $('body');
		var pageType = getPageType();
		var scope = $(this);
		var url = $(this).attr('href');

		var isKeywordDel = $(e.target).hasClass('srp_del');
		if (isKeywordDel) {
			if ($("#srp_search_box .word").length == 1) {
				return;
			}
			url = scope.siblings('a').attr('href')
		}

		contentChangeDeferred(scope, uxview, url, pageType, sellerId);
	}
	));
}

function onPopStateChange(uxview,url,sellerId){
	console.log(url)
	var pageType = getPageType();
	contentChangeDeferred($(".filter-header"), uxview, url, pageType, sellerId, true);
}

function contentChange(uxview, queryParams, pageType, sellerId, onPop) {
	if (window.onUpdatePage) return false;
	window.onUpdatePage = true;
	var url = pageType == "LP" ? "/HomeShopping/{{sellerId}}/Category" : pageType == "SRP" ? "/HomeShopping/{{sellerId}}/Search" : "UNKNOWN";
	if (url == "UNKNOWN") return false;
	if(sellerId == "" || sellerId == undefined){
		url = url.replace("/{{sellerId}}" , "")
	}
	else if(sellerId != ""){
		url = url.replace("{{sellerId}}" , sellerId)
	}
	return ($.ajax({
		type: "GET",
		url: url + queryParams,
		//dataType :"html",
		//data : queryObject,
		success: function (response) {
			if (!onPop) urlSynch(queryParams, pageType, sellerId);
			changeDOM(response, pageType, uxview);
			window.onUpdatePage = false;
		},
		error: function (err) {
			console.log(err.statusText);
			window.onUpdatePage = false;
		}
	}));
}

function changeDOM(html, pageType, uxview) {
	var targetDOM = ['#filter_btn', "#list__sort", "#filter-content", '#item_wrapper', '#price_ul', '#price_a',".box__list",".box__sub-list",".box__layer-content"];
	if (pageType == "SRP") targetDOM = targetDOM.concat(["#srp_search_box", "#category_ul", "#category_btn"]);
	targetDOM.forEach(function (destination) {
		var $data = $(html).find(destination);
		if ($data[0] == undefined) return;
		$(destination).empty().append($data.contents()).attr('href', $data.attr('href'));
		if ($(destination)[0].hasAttribute('class')) {
			$(destination).attr('class', $data.attr('class'));
		}
	});
	if(pageType == 'LP'){
		setSelectedCategoryToMiddleScroll(document.querySelector(".box__list-wrap .item__category.active"), document.querySelector(".box__list-wrap .box__list"), document.querySelector(".box__lp-category .button__category-all"))
		setSelectedCategoryToMiddleScroll(document.querySelector(".box__sub-list-wrap .item__category.active"), document.querySelector(".box__sub-list-wrap .box__sub-list"), null)
		bindCategoryNavigationFloating(uxview);
	}
	var filterBox = '.box__homeshopping-filter';
	$(filterBox).toggleClass('inactive', $(html).find(filterBox).is('.inactive'));
	upateLiveScheduleTimer();
}

function upateLiveScheduleTimer () {
	GMARKET.UI.APP.HOMESHOPPING.PAGE.categoryList = new CategoryList({
		Common: GMARKET.UI.APP.HOMESHOPPING.COMMON,
		LiveScheduleTimer: LiveScheduleTimer
	});
}

function urlSynch(queryStr, pageType, sellerId) {
	console.log("sync")
	pageType == "LP" ? window.history.pushState({}, null, "Category" + queryStr) : window.history.pushState({}, null, "Search" + queryStr);
}

function contentChangeDeferred(scope, uxview, queryStr, pageType, sellerId, onPop) {
	var deferred = contentChange(uxview, queryStr, pageType, sellerId, onPop);
	if (deferred != false) {
		var $parentFilterBox = scope.closest('.filter-detail-box');
		if ($parentFilterBox.length) {
			$parentFilterBox.addClass('loading')
			deferred.always(function () {
				$parentFilterBox.removeClass('loading')
			});
		} else {
			$('#dimmed-layer').addClass('loading');
			deferred.always(function () {
				if (scope.closest('.box__paginate').length) window.scrollTo(0, 0);
				$('#dimmed-layer').removeClass('loading')
			});
		}
	}
}

function filterEventBinding(uxview, sellerId) {
	if(sellerId == "" || sellerId == undefined) sellerId = "";
	$("body")
		.on('click touchmove',function(e){
			if ($(e.target).siblings('.list__sort').length > 0 || !$('.list__sort').hasClass('active')) return true;
			$('.list__sort').toggleClass('active', false);
		})
		.on("click.FilterBtn", ".button__filter", function () {
			// 상세 필터 레이어 열림
			uxview.uio.oFilterLayer.openFilterLayer();
		})
		.on("touchend.FilterLayerCloseBtn", ".filter-layer-close-btn, .dimmed-box", function (e) {
			// 딤레이어 클릭
			// 상세 필터 레이어 닫힘
			event.preventDefault()
			event.stopPropagation()
			uxview.uio.oFilterLayer.closeFilterLayer();
		})
		.on("click.FilterLayerDepth1ARC", ".filter-item-btn.depth-1", function () {
			uxview.uio.oFilterLayer.toggleFilterList({ 'currentTarget': this });
		})
		.on("click.FilterShowMoreBtn", ".show-more-attribute-btn", function () {
			uxview.uio.oFilterLayer.showMoreFilterItem({ 'currentTarget': this });
		})
		.on("click.FilterResetBtn", ".filter-reset-btn", function () {
			// 상세 필터 레이어 설정 UI 초기화 처리
			//uxview.uio.oFilterLayer.closeFilterList('all');
		})
		.on("click.FilterItemBtnDepth2", ".filter-item-btn.depth-2", function () {
			// 라디오, 체크박스 타입 커스텀 UI 상태 토글
			uxview.uio.oFilterLayer.filter.customInput.toggleSelectItem({ 'currentTarget': this });
		})
		.on('keydown.FilterSearchKeyword' , '#filter-detail-search-input',function(e){
			event.keyCode === 13 ? $('.filter-detail-search-btn').trigger('click') : null;
		})
		.on('click.FilterSearchKeyword' , '.filter-detail-search-btn',function(e){
			event.preventDefault();
			if($("#filter-detail-search-input").val() == "") {
				alert("키워드를 입력해주세요."); 
				return false;
			}
			var asisKeywords = $('#asisKeywords').val();
			var keywordList = asisKeywords.split(/\s+/).filter(function (a) { return a });
			var newKeyword = $("#filter-detail-search-input").val().split(/\s+/).filter(function (a) { return a });

			var queryStr = $(".filter-detail-search-btn").attr("href") +"&keyword="+encodeURIComponent(keywordList.concat(newKeyword).join(' '));
			$(".filter-detail-search-btn").attr("href",queryStr);
			var scope = $(this);
			var pageType = getPageType();
			contentChangeDeferred(scope,uxview,$(".filter-detail-search-btn").attr("href"),pageType,sellerId);
		})
		.on('keydown.FilterLayerSearch', '#price-input', function (e) {
			event.keyCode === 13 ? $('.filter-detail-box .set-price-btn').trigger('click') : null;
		})
		.on('click.FilterLayerView','.box__type-view .button__type-view', function() {
			$('.box__type-view .button__type-view').removeClass('active');
			if( $(this).hasClass('button__list-view') ){
				$(this).addClass('active');
				$('.box__homeshopping-items .list__homeshopping-items').addClass('list__type-list');
			}else if( $(this).hasClass('button__gallery-view') ){
				$(this).addClass('active');
				$('.box__homeshopping-items .list__homeshopping-items').removeClass('list__type-list');
			}
		})
		.on('click.FilterLayerPrice', '.filter-detail-box .set-price-btn', function () {

			var prices = uxview.uio.oFilterLayer.filter.price.getPrice();
			if (prices.min != "" && prices.max != "") {
				if (parseInt(prices.min) > parseInt(prices.max)) {
					alert("최고가격을 최저가격보다 크게 입력해주세요.");
					$(".max-price").find("#price-input").focus();
					return;
				}
			}
			// if(prices.max == "") pdsClickLog('200000909', 'Utility', { 'price_from':prices.min });
			// else pdsClickLog('200000909', 'Utility', { 'price_from':prices.min,'price_to': prices.max });

			var queryStr = "&minPrice=" + prices.min + "&maxPrice=" + prices.max;
			var pageType = getPageType();
			var scope = $(this);
			contentChangeDeferred(scope, uxview, $("#price_a").attr('href') + queryStr, pageType, sellerId);

			if (prices.min != "" || prices.max != "") {//가격정보 입력되었으면 클래스명에 active 추가				
				$(".filter-append-area.type-price").find(".filter-title").toggleClass('active', true);
				$(".filter-append-area.type-price").find(".filter-item-btn").toggleClass('active', true);
			}
			else //가격정보 초기화
			{
				$(".filter-append-area.type-price").find(".filter-title").toggleClass('active', false);
				$(".filter-append-area.type-price").find(".filter-item-btn").toggleClass('active', false);
			}
		});
}


// WEBPACK FOOTER //
// ./src/components/lpsrp.js